/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PropertiesCopyIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Properties Copy',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M27 18a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm4.9 10.5h-3.4v3.4a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3.4h-3.4a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3.4v-3.4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3.4h3.4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5ZM2 17.5v-1a.5.5 0 0 1 .5-.5h15.6a5 5 0 0 1 9.8 0s-.559-.007-.9 0a11.217 11.217 0 0 0-1.165.061 2.99 2.99 0 1 0-5.535 2.222 11.105 11.105 0 0 0-1.506 1.4A4.965 4.965 0 0 1 18.1 18H2.5a.5.5 0 0 1-.5-.5Zm0-10v-1a.5.5 0 0 1 .5-.5h3.6a5 5 0 0 1 9.8 0h17.6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H15.9a5 5 0 0 1-9.8 0H2.5a.5.5 0 0 1-.5-.5ZM8 7a3 3 0 1 0 3-3 3 3 0 0 0-3 3Zm7.842 20.961a3 3 0 1 1 0-1.922 11.1 11.1 0 0 1 .565-2.676A4.98 4.98 0 0 0 8.1 26H2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5.6a4.98 4.98 0 0 0 8.306 2.637 11.109 11.109 0 0 1-.564-2.676Z"
    />
  </svg>`;
};
